/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {HeyVRAd} from '@heyvr/sdk-ad-wonderland';
import {FadeToBlack} from '@sorskoot/wonderland-components';
import {Flipbook as Flipbook1} from './flipbook.js';
import {SnapRotate as SnapRotate1} from './snap-rotate.js';
import {Tags as Tags1} from './tags.js';
import {Cursor} from '@wonderlandengine/components';
import {CursorTarget} from '@wonderlandengine/components';
import {HowlerAudioListener} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {PlayerHeight} from '@wonderlandengine/components';
import {Teleport} from './teleport.js';
import {VrModeActiveSwitch} from '@wonderlandengine/components';
import {WasdControlsComponent} from '@wonderlandengine/components';
import {BoxController} from './box-controller.js';
import {Game} from './game.js';
import {HandleTitleState} from './handle-title-state.js';
import {LevelGenerator} from './level-generator.js';
import {MeshParticles} from './mesh-particles.js';
import {PauseController} from './pause-controller.js';
import {PickTarget} from './pick-target.js';
import {ShowInState} from './show-in-state.js';
import {MainUI} from './ui/main-ui.tsx';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(HeyVRAd);
engine.registerComponent(FadeToBlack);
engine.registerComponent(Flipbook1);
engine.registerComponent(SnapRotate1);
engine.registerComponent(Tags1);
engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
engine.registerComponent(HowlerAudioListener);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(Teleport);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(BoxController);
engine.registerComponent(Game);
engine.registerComponent(HandleTitleState);
engine.registerComponent(LevelGenerator);
engine.registerComponent(MeshParticles);
engine.registerComponent(PauseController);
engine.registerComponent(PickTarget);
engine.registerComponent(ShowInState);
engine.registerComponent(MainUI);
/* wle:auto-register:end */
}
